import React from 'react';

import {Button, Anchor} from '@newsela/angelou';

import {signUpRoot} from 'static/three-oh/src/modules/constants/routePaths';

export const JoinLink = React.forwardRef((props, ref) => {
  JoinLink.displayName = 'JoinLink';
  const searchParams = new URLSearchParams({next: window.location.href});

  return (
    <Anchor
      href={`${signUpRoot}?${searchParams.toString()}`}
      ref={ref}
      styleAnchorAsButton={{
        legacy_flavor: Button.legacy_flavor.solid,
        legacy_statusColor: Button.legacy_statusColor.secondary,
      }}
    >
      Join Now
    </Anchor>
  );
});

export default JoinLink;

